"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var CheckBox = function (props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ xmlns: "http://www.w3.org/2000/svg", width: "25", height: "26", viewBox: "0 0 25 26", fill: "none" }, props),
        react_1.default.createElement("rect", { x: "0.5", y: "1", width: "24", height: "24", rx: "2.5", fill: props.checked ? props.color : '#FFFFFF' }),
        react_1.default.createElement("path", { d: "M6 12.7188L10.5 17.2188L19.5 8.21875", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }),
        react_1.default.createElement("rect", { x: "0.5", y: "1", width: "24", height: "24", rx: "2.5", stroke: props.error ? '#D0021B' : props.checked ? props.color : '#898F95' })));
};
exports.CheckBox = CheckBox;
//# sourceMappingURL=CheckBox.js.map